var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.00146C12.837 1.00146 12.2011 1.26486 11.7322 1.7337C11.2634 2.20254 11 2.83842 11 3.50146V13.5015C11 14.1645 11.2634 14.8004 11.7322 15.2692C12.2011 15.7381 12.837 16.0015 13.5 16.0015C14.163 16.0015 14.7989 15.7381 15.2678 15.2692C15.7366 14.8004 16 14.1645 16 13.5015C16 12.8384 15.7366 12.2025 15.2678 11.7337C14.7989 11.2649 14.163 11.0015 13.5 11.0015H3.5C2.83696 11.0015 2.20107 11.2649 1.73223 11.7337C1.26339 12.2025 1 12.8384 1 13.5015C1 14.1645 1.26339 14.8004 1.73223 15.2692C2.20107 15.7381 2.83696 16.0015 3.5 16.0015C4.16304 16.0015 4.79893 15.7381 5.26777 15.2692C5.73661 14.8004 6 14.1645 6 13.5015V3.50146C6 2.83842 5.73661 2.20254 5.26777 1.7337C4.79893 1.26486 4.16304 1.00146 3.5 1.00146C2.83696 1.00146 2.20107 1.26486 1.73223 1.7337C1.26339 2.20254 1 2.83842 1 3.50146C1 4.16451 1.26339 4.80039 1.73223 5.26923C2.20107 5.73807 2.83696 6.00146 3.5 6.00146H13.5C14.163 6.00146 14.7989 5.73807 15.2678 5.26923C15.7366 4.80039 16 4.16451 16 3.50146C16 2.83842 15.7366 2.20254 15.2678 1.7337C14.7989 1.26486 14.163 1.00146 13.5 1.00146Z",
    stroke: "#646D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.643a80b225c7c9c14bb5295f2fee8fba.svg";
export { ForwardRef as ReactComponent };